import axios from 'axios';
import store from '@/store';

export const createHttp = (baseUrl, withCredentials = true) => {
    const http = axios.create({
        baseURL: baseUrl || `${import.meta.env.VITE_API_BASE_URL}`,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        withCredentials: withCredentials,
    });

    http.interceptors.response.use(
        async (resp) => {
            return resp;
        },
        (error) => {
            if (!error.response.config.url.includes('/api/auth/me') && error.response.status === 401) {
                store.dispatch('auth/logout', true);
            }
            return Promise.reject(error);
        },
    );

    return http;
};
